import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowEventRequest,
  WorkflowEventResponse,
  WorkflowProcessPendingResponse,
  WorkflowQueueItemResponse
} from '../models/workflow-runtime.model';

@Injectable({ providedIn: 'root' })
export class WorkflowEventApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-events`;

  constructor(private http: HttpClient) {}

  sendEvent(request: WorkflowEventRequest): Observable<WorkflowEventResponse> {
    return this.http.post<WorkflowEventResponse>(this.apiUrl, request);
  }

  sendBatch(requests: WorkflowEventRequest[]): Observable<WorkflowEventResponse[]> {
    return this.http.post<WorkflowEventResponse[]>(`${this.apiUrl}/batch`, requests);
  }

  getQueue(filters?: { businessId?: number; status?: string; queueType?: string; limit?: number }): Observable<WorkflowQueueItemResponse[]> {
    let params = new HttpParams();
    if (filters?.businessId !== undefined) params = params.set('businessId', filters.businessId.toString());
    if (filters?.status)     params = params.set('status', filters.status);
    if (filters?.queueType)  params = params.set('queueType', filters.queueType);
    if (filters?.limit !== undefined) params = params.set('limit', filters.limit.toString());
    return this.http.get<WorkflowQueueItemResponse[]>(`${this.apiUrl}/queue`, { params });
  }

  processPending(limit?: number): Observable<WorkflowProcessPendingResponse> {
    let params = new HttpParams();
    if (limit !== undefined) params = params.set('limit', limit.toString());
    return this.http.post<WorkflowProcessPendingResponse>(`${this.apiUrl}/process-pending`, {}, { params });
  }
}
